import { LineShapeType, ShapeType } from '../../../../../slide/infrastructure/module/dependent/shape-info/graphic-type';
import i18n from '@i18next/i18n';
//  ------------图形菜单-------------------------


const length = 90;
export const ShapeMenuItems = [

    {
        groupid: 'connectorLine', // 连接线
        grouptype: i18n.t('线条'),
        groupvalue: [
            {
                type: LineShapeType.NoHeadStraight,
                title: i18n.t('直线'),
                height: length * 0.97,
                width: length * 0.97,
            },

            {
                type: LineShapeType.OneEndArrowStraight,
                title: i18n.t('直线箭头'),
                height: length * 0.97,
                width: length * 0.97,
            },

            {
                type: LineShapeType.TwoEndArrowStraight,
                title: i18n.t('双箭头直线'),
                height: length * 0.97,
                width: length * 0.97,
            },
            {
                type: LineShapeType.NoHeadBent,
                title: i18n.t('连接符：肘形'),
                height: length * 0.97,
                width: length * 0.97,
            },
            {
                type: LineShapeType.OneEndArrowBent,
                title: i18n.t('连接符：肘形箭头'),
                height: length * 0.97,
                width: length * 0.97,
            },
            {
                type: LineShapeType.TwoEndArrowBent,
                title: i18n.t('连接符：肘形双箭头'),
                height: length * 0.97,
                width: length * 0.97,
            },

            {
                type: LineShapeType.NoHeadCurved,
                title: i18n.t('连接符：曲线'),
                height: length * 0.97,
                width: length * 0.97,
            },
            {
                type: LineShapeType.OneEndArrowCurved,
                title: i18n.t('连接符：曲线箭头'),
                height: length * 0.97,
                width: length * 0.97,
            },
            {
                type: LineShapeType.TwoEndArrowCurved,
                title: i18n.t('连接符：曲线双箭头'),
                height: length * 0.97,
                width: length * 0.97,
            },
            {
                type: LineShapeType.ArbitraryShape,
                title: i18n.t('任意形状'),
                height: length * 0.97,
                width: length * 0.97,
            },
            {
                type: LineShapeType.FreeCurve,
                title: i18n.t('自由曲线'),
                height: length * 0.97,
                width: length * 0.97,
            },
        ],
    },
    {
        grouptype: i18n.t('矩形'), // 矩形
        groupvalue: [
            {
                type: ShapeType.rect,
                title: i18n.t('矩形'),
                height: length,
                width: length,
            },

            {
                type: ShapeType.roundRect,
                title: i18n.t('矩形：圆角'),
                height: length,
                width: length,
            },

            {
                type: ShapeType.snip1Rect,
                title: i18n.t('矩形：剪去单角'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.snip2SameRect,
                title: i18n.t('矩形：剪去顶角'),
                height: length,
                width: length,
            },

            {
                type: ShapeType.snip2DiagRect,
                title: i18n.t('矩形：剪去对角'),
                height: length,
                width: length,
            },

            {
                type: ShapeType.snipRoundRect,
                title: i18n.t('矩形：一个圆顶角，剪去另一个顶角'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.round1Rect,
                title: i18n.t('矩形：单圆角'),
                height: length,
                width: length,
            },

            {
                type: ShapeType.round2SameRect,
                title: i18n.t('矩形：圆顶角'),
                height: length,
                width: length,
            },

            {
                type: ShapeType.round2DiagRect,
                title: i18n.t('矩形：对角圆角'),
                height: length,
                width: length,
            },
        ],
    },
    {
        grouptype: i18n.t('基本形状'),
        groupvalue: [
            {
                type: ShapeType.ellipse,
                title: i18n.t('椭圆'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.triangle,
                title: i18n.t('等腰三角形'),
                height: length,
                width: 1.15 * length,
            },
            {
                type: ShapeType.rtTriangle,
                title: i18n.t('直角三角形'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.parallelogram,
                title: i18n.t('平行四边形'),
                height: length,
                width: 1.33 * length,
            },
            {
                type: ShapeType.trapezoid,
                title: i18n.t('梯形'),
                height: length,
                width: 1.33 * length,
            },
            {
                type: ShapeType.diamond,
                title: i18n.t('菱形'),
                height: 1.33 * length,
                width: 1.33 * length,
            },
            {
                type: ShapeType.pentagon,
                title: i18n.t('五边形'),
                height: length,
                width: 1.05 * length,
            },
            {
                type: ShapeType.hexagon,
                title: i18n.t('六边形'),
                height: length,
                width: 1.15 * length,
            },
            {
                type: ShapeType.heptagon,
                title: i18n.t('七边形'),
                height: length,
                width: 1.03 * length,
            },
            {
                type: ShapeType.octagon,
                title: i18n.t('八边形'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.decagon,
                title: i18n.t('十边形'),
                height: length,
                width: 1.05 * length,
            },
            {
                type: ShapeType.dodecagon,
                title: i18n.t('十二边形'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.pie,
                title: i18n.t('不完整圆'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.chord,
                title: i18n.t('弦形'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.teardrop,
                title: i18n.t('泪滴形'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.frame,
                title: i18n.t('图文框'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.halfFrame,
                title: i18n.t('半闭框'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.corner,
                title: i18n.t('L形'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.diagStripe,
                title: i18n.t('斜纹'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.plus,
                title: i18n.t('十字形'),
                height: length,
                width: 0.96 * length,
            },
            {
                type: ShapeType.plaque,
                title: i18n.t('缺角矩形'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.can,
                title: i18n.t('圆柱形'),
                height: 1.2 * length,
                width: length,
            },
            {
                type: ShapeType.cube,
                title: i18n.t('立方体'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.bevel,
                title: i18n.t('矩形：棱台'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.donut,
                title: i18n.t('圆：空心'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.noSmoking,
                title: i18n.t('禁止符'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.blockArc,
                title: i18n.t('空心弧'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.foldedCorner,
                title: i18n.t('矩形：折角'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.smileyFace,
                title: i18n.t('笑脸'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.heart,
                title: i18n.t('心形'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.lightningBolt,
                title: i18n.t('闪电形'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.sun,
                title: i18n.t('太阳形'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.moon,
                title: i18n.t('新月形'),
                height: length,
                width: length * 0.5,
            },
            {
                type: ShapeType.cloud,
                title: i18n.t('云形'),
                height: length,
                width: length * 1.3,
            },
            {
                type: ShapeType.arc,
                title: i18n.t('弧形'),
                height: length,
                width: length,
                bg: 'trans',
            },
            {
                type: ShapeType.bracketPair,
                title: i18n.t('双括号'),
                height: length * 0.81,
                width: length * 0.81,
                bg: 'trans',
            },
            {
                type: ShapeType.bracePair,
                title: i18n.t('双大括号'),
                height: length * 0.81,
                width: length * 0.94,
                bg: 'trans',
            },
            {
                type: ShapeType.leftBracket,
                title: i18n.t('矩左中框号'),
                height: length * 0.81,
                width: length * 0.067,
                bg: 'trans',
            },
            {
                type: ShapeType.rightBracket,
                title: i18n.t('右中括号'),
                height: length * 0.81,
                width: length * 0.067,
                bg: 'trans',
            },
            {
                type: ShapeType.leftBrace,
                title: i18n.t('左大括号'),
                height: length * 0.81,
                width: length * 0.13,
                bg: 'trans',
            },
            {
                type: ShapeType.rightBrace,
                title: i18n.t('右大括号'),
                height: length * 0.81,
                width: length * 0.13,
                bg: 'trans',
            },


        ],
    },
    {
        grouptype: i18n.t('箭头总汇'), // 箭头
        groupvalue: [
            {
                type: ShapeType.rightArrow,
                title: i18n.t('箭头：右'),
                height: length * 0.40,
                width: length * 0.81,
            },
            {
                type: ShapeType.leftArrow,
                title: i18n.t('箭头：左'),
                height: length * 0.40,
                width: length * 0.81,
            },
            {
                type: ShapeType.upArrow,
                title: i18n.t('箭头：上'),
                height: length * 0.81,
                width: length * 0.40,
            },
            {
                type: ShapeType.downArrow,
                title: i18n.t('箭头：下'),
                height: length * 0.81,
                width: length * 0.40,
            },
            {
                type: ShapeType.leftRightArrow,
                title: i18n.t('箭头：左右'),
                height: length * 0.40,
                width: length,
            },
            {
                type: ShapeType.upDownArrow,
                title: i18n.t('箭头：上下'),
                height: length,
                width: length * 0.40,
            },
            {
                type: ShapeType.quadArrow,
                title: i18n.t('箭头：十字'),
                height: length * 1.08,
                width: length * 1.08,
            },
            {
                type: ShapeType.leftRightUpArrow,
                title: i18n.t('箭头：丁字'),
                height: length * 0.75,
                width: length * 1.08,
            },
            {
                type: ShapeType.bentArrow,
                title: i18n.t('箭头：圆角右'),
                height: length * 0.81,
                width: length * 0.81,
            },
            {
                type: ShapeType.uturnArrow,
                title: i18n.t('箭头：手杖形'),
                height: length * 0.81,
                width: length * 0.81,
            },
            {
                type: ShapeType.leftUpArrow,
                title: i18n.t('箭头：直角双向'),
                height: length * 0.81,
                width: length * 0.81,
            },
            {
                type: ShapeType.bentUpArrow,
                title: i18n.t('箭头：直角上'),
                height: length * 0.69,
                width: length * 0.81,
            },
            {
                type: ShapeType.curvedRightArrow,
                title: i18n.t('箭头：右弧形'),
                height: length * 0.81,
                width: length * 0.81,
            },
            {
                type: ShapeType.curvedLeftArrow,
                title: i18n.t('箭头：左弧形'),
                height: length * 0.81,
                width: length * 0.81,
            },
            {
                type: ShapeType.curvedUpArrow,
                title: i18n.t('箭头：下弧形'),
                height: length * 0.81,
                width: length * 0.81,
            },
            {
                type: ShapeType.curvedDownArrow,
                title: i18n.t('箭头：上弧形'),
                height: length * 0.81,
                width: length * 0.81,
            },
            {
                type: ShapeType.stripedRightArrow,
                title: i18n.t('箭头：虚尾'),
                height: length * 0.40,
                width: length * 0.81,
            },
            {
                type: ShapeType.notchedRightArrow,
                title: i18n.t('箭头：燕尾形'),
                height: length * 0.40,
                width: length * 0.81,
            },
            {
                type: ShapeType.homePlate,
                title: i18n.t('五边形'),
                height: length * 0.40,
                width: length * 0.81,
            },
            {
                type: ShapeType.chevron,
                title: i18n.t('箭头：V型'),
                height: length * 0.40,
                width: length * 0.81,
            },
            {
                type: ShapeType.rightArrowCallout,
                title: i18n.t('标注：右箭头'),
                height: length * 0.54,
                width: length * 0.81,
            },
            {
                type: ShapeType.downArrowCallout,
                title: i18n.t('标注：下箭头'),
                height: length * 0.81,
                width: length * 0.81,
            },
            {
                type: ShapeType.leftArrowCallout,
                title: i18n.t('标注：左箭头'),
                height: length * 0.54,
                width: length * 0.81,
            },
            {
                type: ShapeType.upArrowCallout,
                title: i18n.t('标注：上箭头'),
                height: length * 0.81,
                width: length * 0.54,
            },
            {
                type: ShapeType.leftRightArrowCallout,
                title: i18n.t('标注：左右箭头'),
                height: length * 0.54,
                width: length * 1.08,
            },
            {
                type: ShapeType.quadArrowCallout,
                title: i18n.t('标注：十字箭头'),
                height: length * 1.08,
                width: length * 1.08,
            },
            {
                type: ShapeType.circularArrow, // todo
                title: i18n.t('箭头：环形'),
                height: length * 1.08,
                width: length * 1.08,
            },


        ],
    },
    {
        grouptype: i18n.t('公式形状'), // 公式
        groupvalue: [
            {
                type: ShapeType.mathPlus,
                title: i18n.t('加号'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.mathMinus,
                title: i18n.t('减号'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.mathMultiply,
                title: i18n.t('乘号'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.mathDivide,
                title: i18n.t('除号'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.mathEqual,
                title: i18n.t('等号'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.mathNotEqual,
                title: i18n.t('不等号'),
                height: length,
                width: length,
            },
        ],
    },
    {
        grouptype: i18n.t('流程图'), // 流程图
        groupvalue: [
            {
                type: ShapeType.flowChartProcess,
                title: i18n.t('流程图：过程'),
                height: length * 0.67,
                width: length,
            },
            {
                type: ShapeType.flowChartAlternateProcess,
                title: i18n.t('流程图：可选过程'),
                height: length * 0.67,
                width: length,
            },
            {
                type: ShapeType.flowChartDecision,
                title: i18n.t('流程图：决策'),
                height: length * 0.67,
                width: length,
            },
            {
                type: ShapeType.flowChartInputOutput,
                title: i18n.t('流程图：数据'),
                height: length * 0.67,
                width: length,
            },
            {
                type: ShapeType.flowChartPredefinedProcess,
                title: i18n.t('流程图：预定义过程'),
                height: length * 0.67,
                width: length,
            },
            {
                type: ShapeType.flowChartInternalStorage,
                title: i18n.t('流程图：内部贮存'),
                height: length * 0.66,
                width: length * 0.66,
            },
            {
                type: ShapeType.flowChartDocument,
                title: i18n.t('流程图：文档'),
                height: length * 0.67,
                width: length,
            },
            {
                type: ShapeType.flowChartMultidocument,
                title: i18n.t('流程图：多文档'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.flowChartTerminator,
                title: i18n.t('流程图：终止'),
                height: length * 0.33,
                width: length,
            },
            {
                type: ShapeType.flowChartPreparation,
                title: i18n.t('流程图：准备'),
                height: length * 0.57,
                width: length,
            },
            {
                type: ShapeType.flowChartManualInput,
                title: i18n.t('流程图：手动输入'),
                height: length * 0.5,
                width: length,
            },
            {
                type: ShapeType.flowChartManualOperation,
                title: i18n.t('流程图：手动操作'),
                height: length * 0.67,
                width: length,
            },
            {
                type: ShapeType.flowChartConnector,
                title: i18n.t('流程图：接点'),
                height: length * 0.5,
                width: length * 0.5,
            },
            {
                type: ShapeType.flowChartOffpageConnector,
                title: i18n.t('流程图：离页连接符'),
                height: length * 0.66,
                width: length * 0.66,
            },
            {
                type: ShapeType.flowChartPunchedCard,
                title: i18n.t('流程图：卡片'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.flowChartPunchedTape,
                title: i18n.t('流程图：资料带'),
                height: length,
                width: length,
            },
            {
                type: ShapeType.flowChartSummingJunction,
                title: i18n.t('流程图：汇总连接'),
                height: length * 0.66,
                width: length * 0.66,
            },
            {
                type: ShapeType.flowChartOr,
                title: i18n.t('流程图：或者'),
                height: length * 0.66,
                width: length * 0.66,
            },
            {
                type: ShapeType.flowChartCollate,
                title: i18n.t('流程图：对照'),
                height: length * 0.5,
                width: length,
            },
            {
                type: ShapeType.flowChartSort,
                title: i18n.t('流程图：排序'),
                height: length,
                width: length * 0.5,
            },
            {
                type: ShapeType.flowChartExtract,
                title: i18n.t('流程图：摘录'),
                height: length,
                width: length * 1.15,
            },
            {
                type: ShapeType.flowChartMerge,
                title: i18n.t('流程图：合并'),
                height: length,
                width: length * 1.15,
            },
            {
                type: ShapeType.flowChartOnlineStorage,
                title: i18n.t('流程图：存储数据'),
                height: length * 0.67,
                width: length,
            },
            {
                type: ShapeType.flowChartDelay,
                title: i18n.t('流程图：延期'),
                height: length * 0.66,
                width: length * 0.66,
            },
            {
                type: ShapeType.flowChartMagneticTape,
                title: i18n.t('流程图：顺序访问存储器'),
                height: length * 0.66,
                width: length * 0.66,
            },
            {
                type: ShapeType.flowChartMagneticDisk,
                title: i18n.t('流程图：磁盘'),
                height: length * 0.67,
                width: length,
            },
            {
                type: ShapeType.flowChartMagneticDrum,
                title: i18n.t('流程图：直接访问存储器'),
                height: length * 0.74,
                width: length,
            },
            {
                type: ShapeType.flowChartDisplay,
                title: i18n.t('流程图：显示'),
                height: length * 0.67,
                width: length,
            },
        ],
    },
    {
        grouptype: i18n.t('星与旗帜'), // 星&旗帜
        groupvalue: [
            {
                type: ShapeType.irregularSeal1,
                title: i18n.t('爆炸型1'),
                height: length * 0.8,
                width: length * 0.8,
            },
            {
                type: ShapeType.irregularSeal2,
                title: i18n.t('爆炸型2'),
                height: length * 0.8,
                width: length * 0.8,
            },
            {
                type: ShapeType.star4,
                title: i18n.t('星形：四角'),
                height: length * 0.8,
                width: length * 0.8,
            },
            {
                type: ShapeType.star5,
                title: i18n.t('星形：五角'),
                height: length * 0.8,
                width: length * 0.85,
            },
            {
                type: ShapeType.star6,
                title: i18n.t('星形：六角'),
                height: 0.91 * length,
                width: 0.78 * length,
            },
            {
                type: ShapeType.star7,
                title: i18n.t('星形：七角'),
                height: length * 0.8,
                width: length * 0.82,
            },
            {
                type: ShapeType.star8,
                title: i18n.t('星形：八角'),
                height: length * 0.8,
                width: length * 0.8,
            },
            {
                type: ShapeType.star10,
                title: i18n.t('星形：十角'),
                height: length * 0.8,
                width: length * 0.85,
            },
            {
                type: ShapeType.star12,
                title: i18n.t('星形：十二角'),
                height: length * 0.8,
                width: length * 0.8,
            },
            {
                type: ShapeType.star16,
                title: i18n.t('星形：十六角'),
                height: length * 0.8,
                width: length * 0.8,
            },
            {
                type: ShapeType.star24,
                title: i18n.t('星形：二十四角'),
                height: length * 0.8,
                width: length * 0.8,
            },
            {
                type: ShapeType.star32,
                title: i18n.t('星形：三十二角'),
                height: length * 0.8,
                width: length * 0.8,
            },
            {
                type: ShapeType.ribbon2,
                title: i18n.t('带形：上凸'),
                height: length * 0.54,
                width: length * 1.08,
            },
            {
                type: ShapeType.ribbon,
                title: i18n.t('带形：前凸'),
                height: length * 0.54,
                width: length * 1.08,
            },
            {
                type: ShapeType.ellipseRibbon2,
                title: i18n.t('带形：上凸弯'),
                height: length * 0.8,
                width: length * 0.8,
            },
            {
                type: ShapeType.ellipseRibbon,
                title: i18n.t('带形：前凸弯'),
                height: length * 0.8,
                width: length * 0.8,
            },
            {
                type: ShapeType.verticalScroll,
                title: i18n.t('卷形：垂直'),
                height: length * 0.8,
                width: length * 0.8,
            },
            {
                type: ShapeType.horizontalScroll,
                title: i18n.t('卷形：水平'),
                height: length * 0.8,
                width: length * 0.8,
            },
            {
                type: ShapeType.wave,
                title: i18n.t('波形'),
                height: length * 0.8,
                width: length * 0.8,
            },
            {
                type: ShapeType.doubleWave,
                title: i18n.t('双波形'),
                height: length * 0.8,
                width: length * 0.8,
            },

        ],
    },
    {
        grouptype: i18n.t('标注'), // 标注
        groupvalue: [
            {
                type: ShapeType.wedgeRectCallout,
                title: i18n.t('对话气泡：矩形'),
                height: length * 0.61,
                width: length * 0.8,
            },
            {
                type: ShapeType.wedgeRoundRectCallout,
                title: i18n.t('对话气泡：圆角矩形'),
                height: length * 0.61,
                width: length * 0.8,
            },
            {
                type: ShapeType.wedgeEllipseCallout,
                title: i18n.t('对话气泡：圆形'),
                height: length * 0.61,
                width: length * 0.8,
            },
            {
                type: ShapeType.cloudCallout,
                title: i18n.t('思想气泡：云'),
                height: length * 0.54,
                width: length * 0.8,
            },
            {
                type: ShapeType.borderCallout1,
                title: i18n.t('标注：线形'),
                height: length * 0.61,
                width: length * 0.8,
            },
            {
                type: ShapeType.borderCallout2,
                title: i18n.t('标注：弯曲线形'),
                height: length * 0.61,
                width: length * 0.8,
            },
            {
                type: ShapeType.borderCallout3,
                title: i18n.t('标注：双弯曲线形'),
                height: length * 0.61,
                width: length * 0.8,
            },
            {
                type: ShapeType.accentCallout1,
                title: i18n.t('标注：线形(带强调线)'),
                height: length * 0.61,
                width: length * 0.8,
            },
            {
                type: ShapeType.accentCallout2,
                title: i18n.t('标注：弯曲线形(带强调线)'),
                height: length * 0.61,
                width: length * 0.8,
            },
            {
                type: ShapeType.accentCallout3,
                title: i18n.t('标注：双弯曲线形(带强调线)'),
                height: length * 0.61,
                width: length * 0.8,
            },
            {
                type: ShapeType.callout1,
                title: i18n.t('标注：线形(无边框)'),
                height: length * 0.61,
                width: length * 0.8,
            },
            {
                type: ShapeType.callout2,
                title: i18n.t('标注：弯曲线形(无边框)'),
                height: length * 0.61,
                width: length * 0.8,
            },
            {
                type: ShapeType.callout3,
                title: i18n.t('标注：双弯曲线形(无边框)'),
                height: length * 0.61,
                width: length * 0.8,
            },
            {
                type: ShapeType.accentBorderCallout1,
                title: i18n.t('标注：线形(带边框和强调线)'),
                height: length * 0.61,
                width: length * 0.8,
            },
            {
                type: ShapeType.accentBorderCallout2,
                title: i18n.t('标注：弯曲线形(带边框和强调线)'),
                height: length * 0.61,
                width: length * 0.8,
            },
            {
                type: ShapeType.accentBorderCallout3,
                title: i18n.t('标注：双弯曲线形(带边框和强调线)'),
                height: length * 0.61,
                width: length * 0.8,
            },
        ],
    },
    {
        grouptype: i18n.t('动作按钮'), // 动作按钮
        groupvalue: [
            {
                type: ShapeType.actionButtonHome,
                title: i18n.t('主页'),
                height: length * 1.14,
                width: length * 1.14,
            },
            {
                type: ShapeType.actionButtonHelp,
                title: i18n.t('帮助'),
                height: length * 1.14,
                width: length * 1.14,
            },
            {
                type: ShapeType.actionButtonInformation,
                title: i18n.t('信息'),
                height: length * 1.14,
                width: length * 1.14,
            },
            {
                type: ShapeType.actionButtonBackPrevious,
                title: i18n.t('上一个'),
                height: length * 1.14,
                width: length * 1.14,
            },
            {
                type: ShapeType.actionButtonForwardNext,
                title: i18n.t('下一个'),
                height: length * 1.14,
                width: length * 1.14,
            },
            {
                type: ShapeType.actionButtonBeginning,
                title: i18n.t('开始'),
                height: length * 1.14,
                width: length * 1.14,
            },
            {
                type: ShapeType.actionButtonEnd,
                title: i18n.t('结束'),
                height: length * 1.14,
                width: length * 1.14,
            },
            {
                type: ShapeType.actionButtonReturn,
                title: i18n.t('返回'),
                height: length * 1.14,
                width: length * 1.14,
            },
            {
                type: ShapeType.actionButtonDocument,
                title: i18n.t('文档'),
                height: length * 1.14,
                width: length * 1.14,
            },
            {
                type: ShapeType.actionButtonSound,
                title: i18n.t('声音'),
                height: length * 1.14,
                width: length * 1.14,
            },
            {
                type: ShapeType.actionButtonMovie,
                title: i18n.t('电影'),
                height: length * 1.14,
                width: length * 1.14,
            },
        ],
    },

];
